// extracted by mini-css-extract-plugin
export default {"container":"WatermarkPill_container__89A5v","logo":"WatermarkPill_logo__ty7le"};